import { v4 as uuid } from "uuid";
import { z } from "zod";
import { ProjectAccessLevel } from "../../entities/project";
export var ProfileStatus;
(function (ProfileStatus) {
    ProfileStatus["Active"] = "profile-status_active";
    ProfileStatus["Invited"] = "profile-status_invited";
})(ProfileStatus || (ProfileStatus = {}));
export const profileTypeToString = (profileType) => {
    return profileType ? "Admin" : "Standard";
};
export const profileStatusToString = (profileStatus) => {
    switch (profileStatus) {
        case ProfileStatus.Active:
            return "Active";
        case ProfileStatus.Invited:
            return "Invited";
    }
};
export const createDefaultProfile = (organisation, user) => {
    return {
        created: new Date(),
        disabledNotificationTypes: [],
        email: user ? user.email : "",
        emailNotifications: true,
        firstName: "",
        id: user ? user.id : uuid(),
        isAdmin: false,
        isSetup: false,
        lastName: "",
        organisationId: organisation ? organisation.id : uuid(),
        status: ProfileStatus.Active
    };
};
export const createInvite = (email) => {
    return {
        created: new Date(),
        disabledNotificationTypes: [],
        email: email,
        emailNotifications: false,
        firstName: "",
        id: uuid(),
        isAdmin: false,
        isSetup: false,
        lastName: "",
        organisationId: "",
        status: ProfileStatus.Invited
    };
};
export const NO_ORGANISATION_ID = "NO-ORGANISATION-ID";
export const profileForPackageLineItemSchema = z.object({
    accessLevel: z.enum(ProjectAccessLevel),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string()
});
export const profileLineItemSchema = z.object({
    created: z.date(),
    /** NotificationType values switched off in Settings; empty means show all. */
    // Optional for the same reason as the entity field: plenty of call sites build a
    // ProfileLineItem by hand, and absent means the same as empty — nothing hidden.
    disabledNotificationTypes: z.array(z.string()).optional(),
    email: z.string(),
    emailNotifications: z.boolean(),
    federatedUser: z.boolean().optional(),
    firstName: z.string(),
    id: z.string(),
    isAdmin: z.boolean(),
    isContractor: z.boolean().optional(),
    isSetup: z.boolean(),
    lastName: z.string(),
    mfaEnrolled: z.boolean().optional(),
    organisationId: z.string(),
    // The user's org MFA policy, surfaced onto the profile so the frontend
    // route-gate can decide without a separate org fetch.
    organisationMfaEnabled: z.boolean().optional(),
    profileLogo: z.string().optional(),
    profileLogoSrc: z.string().optional(),
    status: z.enum(ProfileStatus)
});
